import { Component } from '@angular/core';
import { News } from './../../models/news/news.model';
import { CommunicationService } from './../../shared/services/communication.service';

import { ApiService } from './../../shared/services/api.service';
import { ListBase } from './../../shared/components/base/list/list.base.component';

@Component({
  selector: 'swb-news-list',
  templateUrl: './../../shared/components/base/list/list.base.component.html',
})
export class NewsListComponent extends ListBase<News> {

  public url = 'news';
  public routePrefix = 'news';

  constructor(
    _apiService: ApiService,
    _communicationService: CommunicationService
  ) {
    super(
      _apiService,
      _communicationService
    );
  }
}
